<footer id="footer" class="footer">
  <div class="container-fluid">
    <ul class="footer__links list-unstyled">
      <li><a [href]="globalQuestionService?.getSection(sectionType.footer, entryType.right_about)?.link_url" target="_blank"> {{globalQuestionService?.getSection(sectionType.footer, entryType.right_about)?.description}}</a></li>
      <li><a [href]="globalQuestionService?.getSection(sectionType.footer, entryType.right_terms)?.link_url" target="_blank">{{globalQuestionService?.getSection(sectionType.footer, entryType.right_terms)?.description}}</a></li>
      <li><a [href]="globalQuestionService?.getSection(sectionType.footer, entryType.right_privacy)?.link_url" target="_blank">{{globalQuestionService?.getSection(sectionType.footer, entryType.right_privacy)?.description}}</a></li>
      <li><a [href]="globalQuestionService?.getSection(sectionType.footer, entryType.right_help)?.link_url" >{{globalQuestionService?.getSection(sectionType.footer, entryType.right_help)?.description}}</a></li>
    </ul>
    <div class="footer__meta">
      {{globalQuestionService?.getSection(sectionType.footer, entryType.left)?.description}}
    </div>
  </div>
</footer>
